import React from 'react';

import logo from '../assets/images/logo-grey-100.svg'
import discordIcon from '../assets/images/icons/discord-24px.svg'
import twitterIcon from '../assets/images/icons/twitter-24px.svg'
import instagramIcon from '../assets/images/icons/instagram-24px.svg'
import youtubeIcon from '../assets/images/icons/youtube-24px.svg'

const Footer = () => {
  return (
    <footer>
      <div className='footer-content'>
        <div className='company-copyright'>
          <div className='company-signs'>
            <img src={logo} alt='Love laces'/>
            <h1>LVLCS</h1>
          </div>

          <ul>
            <li>
              <a href="https://discord.gg/N9Q4Jr7g" target="_blank">
                <img src={discordIcon} alt='Discord'/>
              </a>
            </li>
            <li>
              <a href="https://twitter.com/LVLCS_io" target="_blank">
                <img src={twitterIcon} alt='Twitter'/>
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/lvlcs_io/" target="_blank">
                <img src={instagramIcon} alt='Instagram'/>
              </a>
            </li>
            <li>
              <a href="https://www.youtube.com/channel/UCzsYpzxu0dQs8xbRDRdUEgA" target="_blank">
                <img src={youtubeIcon} alt='Youtube'/>
              </a>
            </li>
          </ul>

          <p>
            LVLCS is a registered trademark of LVLCS Inc. All Rights Reserved. LVLCS All logos are registered trademarks of their respective owners. All contents of this document, unless otherwise credited, are copyright © 2023 LVLCS Inc.
          </p>
        </div>

        <div className='company-information'>
          <nav>
            <a href="https://www.lvlcs.io/lvlcs-faq" target="_blank">FAQ</a>
            <a href="https://www.lvlcs.io/" target="_blank">About Us</a>
            <a href="https://www.lvlcs.io/contact" target="_blank">Contact Us</a>
            <a href="https://www.lvlcs.io/terms-conditions" target="_blank">Terms & Conditions</a>
            <a href="https://www.lvlcs.io/privacy-policy" target="_blank">Privacy Policy</a>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;